import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=5d563579&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=5d563579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d563579",
  null
  
)

export default component.exports